import Box from '@/components/UI/box/Box'
import Typography from '@/components/UI/typography/Typography'
import { useRouter } from 'next/router'
import useLogin from '../../hooks/useLogin'
import Icon from '@/components/UI/icon/Icon'
import styles from './ShowHostPanelCTA.module.scss'

const ShowHostPanelCTA = () => {
  const router = useRouter()
  const { onClose } = useLogin()
  return (
    <Box
      className={`${styles['show-host-panel-cta']} ${styles['slide-in-right']}`}
    >
      <Typography variant="bodyM">
        میزبان عزیز، قصد ورود به کدام بخش را دارید؟
      </Typography>
      <Box
        onClick={() => {
          onClose && onClose()
          router.push('/panel/host')
        }}
        className={styles['btn-link']}
      >
        <Typography variant="bodyM">ورود به پنل مدیریت اقامتگاه</Typography>
        <Icon type={'disabled'} name={'arrow-left-1'} />
      </Box>
      <Box
        onClick={() => {
          onClose && onClose()
        }}
        className={styles['btn-link']}
      >
        <Typography variant="bodyM">ادامه در سایت شب</Typography>
        <Icon type={'disabled'} name={'arrow-left-1'} />
      </Box>
    </Box>
  )
}

export default ShowHostPanelCTA
